import ReactDOM from 'react-dom/client';
//
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

// ----------------------------------------------------------------------

// 配置 Monaco Editor 使用本地资源，避免从 CDN 加载
(window as any).MonacoEnvironment = {
  getWorkerUrl: function (moduleId: string, label: string) {
    // 这些路径指向 webpack 构建后的 worker 文件
    switch (label) {
      case 'json':
        return `/static/js/json.worker.js`;
      case 'css':
      case 'scss':
      case 'less':
        return `/static/js/css.worker.js`;
      case 'html':
      case 'handlebars':
      case 'razor':
        return `/static/js/html.worker.js`;
      case 'typescript':
      case 'javascript':
        return `/static/js/ts.worker.js`;
      case 'yaml':
      default:
        return `/static/js/editor.worker.js`;
    }
  }
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
